const _excluded = ["iconStyles", "iconClassName", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from './Button';
export function UndoButton(_ref) {
  let {
      iconStyles,
      iconClassName,
      variant = 'light'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const defaultIconClassName = 'text-warning rounded-circle mx-auto';
  const passedIconClassName = iconClassName ? iconClassName : defaultIconClassName;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: variant,
    className: "p-1 d-inline-flex rounded-circle",
    icon: "undo",
    iconClassName: passedIconClassName
  }, props));
}